import React from 'react';
import ReactTooltip from 'react-tooltip';
import { defaultTemplate } from 'core/hoc';

const AmazonInventoryMergeTooltip = ({ t, id, isSellerLevel = false }) => {
	return (
		<React.Fragment>
			<ReactTooltip id={id} place="top" effect="solid">
				<div style={{ maxWidth: 360, whiteSpace: 'normal' }}>
					<p className="spc--bottom--sml">
						<strong>{t('AMAZONINVENTORYMERGETOOLTIP.TITLE')}</strong>
					</p>
					<p className="spc--bottom--sml">{t('AMAZONINVENTORYMERGETOOLTIP.ON')}</p>
					<p className="spc--bottom--sml">{t('AMAZONINVENTORYMERGETOOLTIP.OFF')}</p>
					<p className="spc--bottom--sml">
						{t(isSellerLevel ? 'AMAZONINVENTORYMERGETOOLTIP.SELLERSCOPE' : 'AMAZONINVENTORYMERGETOOLTIP.SKUSCOPE')}
					</p>
				</div>
			</ReactTooltip>

			<i data-for={id} data-tip="" className="fa fa-info-circle spc--left--tny"></i>
		</React.Fragment>
	);
};

export default defaultTemplate(AmazonInventoryMergeTooltip);
